import React, { ChangeEvent, ChangeEventHandler } from "react";
import { Helmet } from "react-helmet";
import { NavbarWithMegaMenu } from "../components/navbar";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import {
  TrashIcon,
  PencilSquareIcon,
  PlusCircleIcon,
  InformationCircleIcon,
} from "@heroicons/react/24/outline";
import {
  Button,
  Checkbox,
  Typography,
  Tooltip,
  Textarea,
  Spinner,
  Input,
} from "@material-tailwind/react";
import { FileInput } from "flowbite-react";
import DeuFlagImg from "../../images/flags/deuflage.png";
import AMFlagImg from "../../images/flags/amflag.png";
import { useState, useRef } from "react";
import { collection, addDoc } from "firebase/firestore";
import { db } from "../../config/firebase-config";

import {
  handleAudioInputFileChange,
  handleImageInputFileChange,
  handleImagesInputFileChange,
  IAudio,
  IImages,
  removeImageFromState,
  resetAudio,
  updateImageDescriptionChange,
  updateImageIsModalOpen,
} from "src/utils/form/updateFieldStateUtil";
import { uploadFile } from "src/utils/firebase/firebaseUtil";
import { IPoi } from "src/features/firebase/dataStructure/Poi";
const NewPoiPage = () => {
  const navigate = useNavigate();
  const audioRefDe = useRef<HTMLAudioElement>(null);
  const audioRefEn = useRef<HTMLAudioElement>(null);
  const storyRefDe = useRef<HTMLAudioElement>(null);
  const storyRefEn = useRef<HTMLAudioElement>(null);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  // const [imagePanel, setImagePanel] = useState(Date.now());
  const [firstTextHeadingDe, setFirstTextHeadingDe] = useState("");
  const [firstTextHeadingEn, setFirstTextHeadingEn] = useState("");
  const [nameDe, setNameDe] = useState("");
  const [nameEn, setNameEn] = useState("");
  const [addressDe, setAddressDe] = useState("");
  const [addressEn, setAddressEn] = useState("");
  const [descEn, setDescEn] = useState("");
  const [descDe, setDescDe] = useState("");
  const [published, setPublished] = useState(false);

  // const [linksDe, setLinksDe] = useState([]);
  // const [linksEn, setLinksEn] = useState([]);
  const [firstTextHeadingDeError, setFirstTextHeadingDeError] = useState(false);
  const [firstTextHeadingEnError, setFirstTextHeadingEnError] = useState(false);
  const [nameDeError, setNameDeError] = useState(false);
  const [nameEnError, setNameEnError] = useState(false);
  const [descDeError, setDescDeError] = useState(false);
  const [descEnError, setDescEnError] = useState(false);

  const [tipDescDe, setTipDescDe] = useState("");
  const [tipDescEn, setTipDescEn] = useState("");
  const [tipLinkDe, setTipLinkDe] = useState("");
  const [tipLinkEn, setTipLinkEn] = useState("");

  const [willbeHidden, setWillbeHidden] = useState(false);
  const [isAR, setIsAR] = useState(false);
  const [isPanorama, setIsPanorama] = useState(false);
  const [GPS, setGPS] = useState("");
  const [GPSError, setGPSError] = useState(false);
  const [facebookDe, setFacebookDe] = useState("");
  const [facebookEn, setFacebookEn] = useState("");
  const [instagramDe, setInstagramDe] = useState("");
  const [instagramEn, setInstagramEn] = useState("");
  const [weblinkDe, setWeblinkDe] = useState("");
  const [weblinkEn, setWeblinkEn] = useState("");
  const [videoNameDe, setVideoNameDe] = useState("");
  const [videoNameEn, setVideoNameEn] = useState("");
  const [videoLinkDe, setVideoLinkDe] = useState("");
  const [videoLinkEn, setVideoLinkEn] = useState("");

  const [fileDe, setFileDe] = useState<File | null>(null);
  const [fileEn, setFileEn] = useState<File | null>(null);
  const [tipDe, setTipDe] = useState<File | null>(null);
  // const [tipEn, setTipEn] = useState<File | null>(null);
  const [storyDe, setStoryDe] = useState<File | null>(null);
  const [storyEn, setStoryEn] = useState<File | null>(null);
  const [thumbDe, setThumbDe] = useState<File | null>(null);

  const [audioSrcDe, setAudioSrcDe] = useState<IAudio>(null);
  const [audioSrcEn, setAudioSrcEn] = useState<IAudio>(null);
  const [storySrcDe, setStorySrcDe] = useState<IAudio>(null);
  const [storySrcEn, setStorySrcEn] = useState<IAudio>(null);

  const [thumbSrcDe, setThumbSrcDe] = useState<IAudio>(null);
  const [isModalOpenThumb, setIsModalOpenThumb] = useState<boolean>(false);
  const [tipSrcDe, setTipSrcDe] = useState<IAudio>(null);
  const [isModalOpenTip, setIsModalOpenTip] = useState(false);

  const [arImageSrcDe, setARImageSrcDe] = useState<IAudio>(null);
  const [isModalOpenAR, setIsModalOpenAR] = useState(false);
  const [panoramaImageSrcDe, setPanoramaImageSrcDe] = useState<IAudio>(null);
  const [isModalOpenPanorama, setIsModalOpenPanorama] = useState(false);
  // const [thumbEn, setThumbEn] = useState(null);
  const [fileARImage, setFileARImage] = useState<File | null>(null);
  const [filePanoramaImage, setFilePanoramaImage] = useState<File | null>(null);

  const [images, setImages] = useState<IImages[]>([]);

  const handleFileDeChange: ChangeEventHandler<HTMLInputElement> = (event) =>
    handleAudioInputFileChange(event, setFileDe, setAudioSrcDe, resetAudioDe);
  const handleFileEnChange: ChangeEventHandler<HTMLInputElement> = (event) =>
    handleAudioInputFileChange(event, setFileEn, setAudioSrcEn, resetAudioEn);
  const resetAudioDe = () => resetAudio(audioRefDe);
  const resetAudioEn = () => resetAudio(audioRefEn);

  const handleBilderChange = (
    index: number,
    event: ChangeEvent<HTMLInputElement>
  ) => handleImagesInputFileChange(event, index, setImages);

  const removeImage = (index: number) =>
    removeImageFromState(index, images, setImages);

  const modalToggle = (index: number, isOpen: boolean) =>
    updateImageIsModalOpen(images, index, isOpen, setImages);

  const handleTipDeChange: ChangeEventHandler<HTMLInputElement> = (event) =>
    handleImageInputFileChange(event, setTipDe, setTipSrcDe);

  const modalToggleTip = (isOpen) => setIsModalOpenTip(isOpen);

  const handleThumbDeChange: ChangeEventHandler<HTMLInputElement> = (event) =>
    handleImageInputFileChange(event, setThumbDe, setThumbSrcDe);

  const modalToggleThumb = (isOpen) => setIsModalOpenThumb(isOpen);

  // const handleThumbEnChange = (event) => {
  //   const selectedFile = event.target.files[0];
  //   setThumbEn(selectedFile);
  // };

  const handleAudioStoryDeChange: ChangeEventHandler<HTMLInputElement> = (
    event
  ) =>
    handleAudioInputFileChange(event, setStoryDe, setStorySrcDe, resetStoryDe);

  const handleAudioStoryEnChange: ChangeEventHandler<HTMLInputElement> = (
    event
  ) =>
    handleAudioInputFileChange(event, setStoryEn, setStorySrcEn, resetStoryEn);

  const resetStoryDe = () => resetAudio(storyRefDe);
  const resetStoryEn = () => resetAudio(storyRefEn);

  const handleFileARImageChange = (event: ChangeEvent<HTMLInputElement>) =>
    handleImageInputFileChange(event, setFileARImage, setARImageSrcDe);

  const handleFilePanoramaImageChange = (
    event: ChangeEvent<HTMLInputElement>
  ) =>
    handleImageInputFileChange(
      event,
      setFilePanoramaImage,
      setPanoramaImageSrcDe
    );

  const modalToggleAR = (isOpen) => setIsModalOpenAR(isOpen);

  const modalTogglePanorama = (isOpen) => setIsModalOpenPanorama(isOpen);

  // Function to add a new item to the linksDe array
  const addNewImage = () => {
    setImages([
      ...images,
      {
        imageUrl: "",
        imageFile: null,
        imageDescriptionDe: "",
        imageDescriptionEn: "",
        previewUrl: null,
        isModalOpen: false,
        isHidden: false,
      },
    ]); // Add a new empty string to the array
  };
  const handleInputDeChange = (
    index: number,
    event: ChangeEvent<HTMLInputElement>
  ) => updateImageDescriptionChange(images, index, event, setImages, "de");
  // const handleInputDeChange = (index, event) => {
  //   const newImages = [...images]; // Create a copy of the state array
  //   newImages[index].imageDescriptionDe = event.target.value; // Update the specific index with the new value
  //   setImages(newImages); // Update the state
  // };
  const handleInputEnChange = (
    index: number,
    event: ChangeEvent<HTMLInputElement>
  ) => updateImageDescriptionChange(images, index, event, setImages, "en");
  // const handleInputEnChange = (index, event) => {
  //   const newImages = [...images]; // Create a copy of the state array
  //   newImages[index].imageDescriptionEn = event.target.value; // Update the specific index with the new value
  //   setImages(newImages); // Update the state
  // };

  // const [fileDeUrl, setFileDeUrl] = useState("");
  // const [fileEnUrl, setFileEnUrl] = useState("");

  const onSubmit = async () => {
    if (!firstTextHeadingDe) {
      setError(true);
      setFirstTextHeadingDeError(true);
      return;
    }
    if (!firstTextHeadingEn) {
      setError(true);
      setFirstTextHeadingEnError(true);
      return;
    }
    if (!nameDe) {
      setError(true);
      setNameDeError(true);
      return;
    }
    if (!nameEn) {
      setError(true);
      setNameEnError(true);
      return;
    }
    if (!descDe) {
      setDescDeError(true);
      setError(true);
      return;
    }
    if (!descEn) {
      setDescEnError(true);
      setError(true);
      return;
    }
    if (!GPS) {
      setGPSError(true);
      setError(true);
      return;
    }

    setLoading(true);

    const filteredImages = images.filter(
      (image) => image.imageFile !== null && image.isHidden === false
    );

    const imageUploadPromises = filteredImages.map(async (image) => {
      image.imageUrl = await uploadFile(image.imageFile);
      return image.imageUrl;
      // if (image.imageFile) {
      //   return uploadFile(image.imageFile).then((url) => {
      //     image.imageUrl = url; // Directly set the image URL
      //   });
      // }
    });

    // Await all uploads
    await Promise.all([...imageUploadPromises]);

    const imageUrls: string[] = [];
    filteredImages.forEach((image) => {
      if (image.imageUrl) imageUrls.push(image.imageUrl);
    });
    const imageDescriptionsDe: string[] = [];
    filteredImages.forEach((image) => {
      if (image.imageDescriptionDe)
        imageDescriptionsDe.push(image.imageDescriptionDe);
    });

    const imageDescriptionsEn: string[] = [];
    filteredImages.forEach((image) => {
      if (image.imageDescriptionEn)
        imageDescriptionsEn.push(image.imageDescriptionEn);
    });

    const [
      ARImageUrl,
      filePanoramaImageUrl,
      thumbDeUrl,
      tipDeUrl,
      storyDeUrl,
      fileDeUrl,
      storyEnUrl,
      fileEnUrl,
    ] = await Promise.all([
      fileARImage && uploadFile(fileARImage),
      filePanoramaImage && uploadFile(filePanoramaImage),
      thumbDe && uploadFile(thumbDe),
      tipDe && uploadFile(tipDe),
      storyDe && uploadFile(storyDe),
      fileDe && uploadFile(fileDe),
      storyEn && uploadFile(storyEn),
      fileEn && uploadFile(fileEn),
    ]);

    const poiData: IPoi = {
      ARImage: ARImageUrl,
      PanoramaImage: filePanoramaImageUrl,
      ThumbnailImage: thumbDeUrl,
      TipImage: tipDeUrl,
      arActive: isAR,
      arScenelsPanorama: isPanorama,
      gps: GPS,
      images: imageUrls,
      hideInOverview: willbeHidden,
      languages: {
        de: {
          FirstTextHeading: firstTextHeadingDe,
          POIAddress: addressDe,
          TipDescription: tipDescDe,
          TipLink: tipLinkDe,
          VideoName: videoNameDe,
          audiostory: storyDeUrl,
          firstAudio: fileDeUrl,
          firstText: descDe,
          imagesDescription: imageDescriptionsDe,
          name: nameDe,
          videoLink: videoLinkDe,
          facebookLink: facebookDe,
          instagramLink: instagramDe,
          weblink: weblinkDe,
        },
        en: {
          FirstTextHeading: firstTextHeadingEn,
          POIAddress: addressEn,
          TipDescription: tipDescEn,
          TipLink: tipLinkEn,
          VideoName: videoNameEn,
          audiostory: storyEnUrl,
          firstAudio: fileEnUrl,
          firstText: descEn,
          imagesDescription: imageDescriptionsEn,
          name: nameEn,
          videoLink: videoLinkEn,
          facebookLink: facebookEn,
          instagramLink: instagramEn,
          weblink: weblinkEn,
        },
      },
      published: published,
    };

    await addDoc(collection(db, "poi"), poiData);
    setLoading(false);
    navigate("/poi");
  };
  return (
    <>
      {/* @ts-ignore */}
      <Helmet>
        <title>Neuen POI erstellen | BremenGo</title>
        <meta name="description" content="BremenGo Home Screen" />
      </Helmet>
      <NavbarWithMegaMenu />
      {loading && (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-gray-900 bg-opacity-75">
          {/* @ts-ignore */}
          <Spinner size="3xl" color="white" />
        </div>
      )}
      <div className="border-b-4 border-[#5A5A5A] mx-5">
        <div className="container m-auto mt-20 pb-12">
          <h1 className="text-[#5A5A5A] text-3xl font-medium">
            Neuen POI erstellen
          </h1>
        </div>
      </div>
      <div className="container m-auto mt-12">
        <div className="grid lg:grid-cols-2 gap-6">
          <div>
            <div className="text-center m-auto mb-16">
              <img src={DeuFlagImg} className="m-auto" />
            </div>
            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1">
                <Tooltip content="Max. 18 Zeichen" placement="top">
                  <InformationCircleIcon
                    strokeWidth={2}
                    className="h-10 w-10 text-[#5A5A5A]"
                  ></InformationCircleIcon>
                </Tooltip>
              </div>
              <div className="col-span-11">
                <div className="grid grid-cols-12">
                  <div className="col-span-3 flex items-center justify-end pr-2 text-[#5A5A5A] text-xl">
                    Name
                  </div>
                  <div className="col-span-9">
                    {/* @ts-ignore */}
                    <Input
                      className="bg-white"
                      icon={<PencilSquareIcon />}
                      value={nameDe}
                      onChange={(e) => {
                        setNameDe(e.target.value);
                        setNameDeError(false);
                        setError(false);
                      }}
                    />
                    {nameDeError ? (
                      <p className="text-red-800">
                        Please fill out this field.
                      </p>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1">
                <Tooltip
                  content="Unbegrenzte Anzahl an Zeichen"
                  placement="top"
                >
                  <InformationCircleIcon
                    strokeWidth={2}
                    className="h-10 w-10 text-[#5A5A5A]"
                  ></InformationCircleIcon>
                </Tooltip>
              </div>
              <div className="col-span-11">
                <div className="grid grid-cols-12">
                  <div className="col-span-3 flex items-center justify-end pr-2 text-[#5A5A5A] text-xl">
                    Überschrift
                  </div>
                  <div className="col-span-9">
                    {/* @ts-ignore */}
                    <Input
                      className="bg-white"
                      icon={<PencilSquareIcon />}
                      value={firstTextHeadingDe}
                      onChange={(e) => {
                        setFirstTextHeadingDe(e.target.value);
                        setFirstTextHeadingDeError(false);
                        setError(false);
                      }}
                    />
                    {firstTextHeadingDeError ? (
                      <p className="text-red-800">
                        Please fill out this field.
                      </p>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1">
                <Tooltip
                  content="Unbegrenzte Anzahl an Zeichen"
                  placement="top"
                >
                  <InformationCircleIcon
                    strokeWidth={2}
                    className="h-10 w-10 text-[#5A5A5A]"
                  ></InformationCircleIcon>
                </Tooltip>
              </div>
              <div className="col-span-11">
                <div className="grid grid-cols-12">
                  <div className="col-span-3 flex items-center justify-end pr-2 text-[#5A5A5A] text-xl">
                    Adresse
                  </div>
                  <div className="col-span-9">
                    {/* @ts-ignore */}
                    <Input
                      className="bg-white"
                      icon={<PencilSquareIcon />}
                      value={addressDe}
                      onChange={(e) => {
                        setAddressDe(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1">
                <Tooltip
                  content="Unbegrenzte Anzahl an Zeichen"
                  placement="top"
                >
                  <InformationCircleIcon
                    strokeWidth={2}
                    className="h-10 w-10 text-[#5A5A5A]"
                  ></InformationCircleIcon>
                </Tooltip>
              </div>
              <div className="col-span-11">
                <div className="grid grid-cols-12">
                  <div className="col-span-3 flex items-center justify-end pr-2 text-[#5A5A5A] text-xl">
                    Text
                  </div>
                  <div className="col-span-9">
                    <Textarea
                      className="bg-white"
                      // @ts-ignore
                      icon={<PencilSquareIcon />}
                      value={descDe}
                      onChange={(e) => {
                        setDescDeError(false);
                        setError(false);
                        setDescDe(e.target.value);
                      }}
                    />
                    {descDeError ? (
                      <p className="text-red-800">
                        Please fill out this field.
                      </p>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1">
                <Tooltip
                  content="Vorlesetext für Barrierefreiheit, Audioformat: mp3, max. Dateigröße: 200kB"
                  placement="top"
                >
                  <InformationCircleIcon
                    strokeWidth={2}
                    className="h-10 w-10 text-[#5A5A5A]"
                  ></InformationCircleIcon>
                </Tooltip>
              </div>
              <div className="col-span-11">
                <div className="grid grid-cols-12">
                  <div className="col-span-3 flex items-center justify-end pr-2 text-[#5A5A5A] text-xl">
                    Audio
                  </div>
                  <div className="col-span-9">
                    <FileInput
                      className="text-[#5A5A5A]"
                      accept="audio/*"
                      id="file-upload"
                      onChange={handleFileDeChange}
                    />
                    {audioSrcDe && (
                      <audio ref={audioRefDe} controls className="mt-2">
                        {/* @ts-ignore */}
                        <source src={audioSrcDe} type="audio/mp3" />
                        Your browser does not support the audio tag.
                      </audio>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1">
                <Tooltip
                  content="Audiostory, Audioformat: mp3, max. Dateigröße: 200kB"
                  placement="top"
                >
                  <InformationCircleIcon
                    strokeWidth={2}
                    className="h-10 w-10 text-[#5A5A5A]"
                  ></InformationCircleIcon>
                </Tooltip>
              </div>
              <div className="col-span-11">
                <div className="grid grid-cols-12">
                  <div className="col-span-3 flex items-center justify-end pr-2 text-[#5A5A5A] text-xl">
                    AudioStory
                  </div>
                  <div className="col-span-9">
                    <FileInput
                      className="text-[#5A5A5A]"
                      accept="audio/*"
                      id="file-upload"
                      onChange={handleAudioStoryDeChange}
                    />
                    {storySrcDe && (
                      <audio ref={storyRefDe} controls className="mt-2">
                        {/* @ts-ignore */}
                        <source src={storySrcDe} type="audio/mp3" />
                        Your browser does not support the audio tag.
                      </audio>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1">
                <Tooltip content="Video Name" placement="top">
                  <InformationCircleIcon
                    strokeWidth={2}
                    className="h-10 w-10 text-[#5A5A5A]"
                  ></InformationCircleIcon>
                </Tooltip>
              </div>
              <div className="col-span-11">
                <div className="grid grid-cols-12">
                  <div className="col-span-3 flex items-center justify-end pr-2 text-[#5A5A5A] text-xl">
                    Video Überschrift
                  </div>
                  <div className="col-span-9">
                    {/* @ts-ignore */}
                    <Input
                      className="bg-white"
                      icon={<PencilSquareIcon />}
                      value={videoNameDe}
                      onChange={(e) => {
                        setVideoNameDe(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1">
                <Tooltip content="Video Vorschaubild" placement="top">
                  <InformationCircleIcon
                    strokeWidth={2}
                    className="h-10 w-10 text-[#5A5A5A]"
                  ></InformationCircleIcon>
                </Tooltip>
              </div>
              <div className="col-span-11">
                <div className="grid grid-cols-12">
                  <div className="col-span-3 flex items-center justify-end pr-2 text-[#5A5A5A] text-xl">
                    Video Vorschaubild
                  </div>
                  <div className="col-span-9">
                    <FileInput
                      className="text-[#5A5A5A]"
                      id="file-upload"
                      accept="image/*"
                      onChange={handleThumbDeChange}
                    />
                    {thumbSrcDe && (
                      <div className="relative mt-2 w-[max-content]">
                        {/* Thumbnail Preview */}
                        <img
                          //@ts-ignore
                          src={thumbSrcDe}
                          alt="Preview"
                          className="w-72 h-auto rounded-lg shadow-lg cursor-pointer transition-transform hover:scale-105"
                          onClick={() => modalToggleThumb(true)} // Open modal on click
                        />

                        {/* Full-Size Modal */}
                        {isModalOpenThumb && (
                          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                            <img
                              //@ts-ignore
                              src={thumbSrcDe}
                              alt="Full Size Preview"
                              className="max-w-full max-h-full rounded-lg shadow-xl"
                            />
                            <button
                              className="absolute top-4 right-4 bg-white text-black p-2 rounded-full shadow-md"
                              onClick={() => modalToggleThumb(false)} // Close modal on click
                            >
                              ✕
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1">
                <Tooltip content="Vimeo Weblink" placement="top">
                  <InformationCircleIcon
                    strokeWidth={2}
                    className="h-10 w-10 text-[#5A5A5A]"
                  ></InformationCircleIcon>
                </Tooltip>
              </div>
              <div className="col-span-11">
                <div className="grid grid-cols-12">
                  <div className="col-span-3 flex items-center justify-end pr-2 text-[#5A5A5A] text-xl">
                    Video Link
                  </div>
                  <div className="col-span-9">
                    {/* @ts-ignore */}
                    <Input
                      className="bg-white"
                      icon={<PencilSquareIcon />}
                      value={videoLinkDe}
                      onChange={(e) => {
                        setVideoLinkDe(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="text-center m-auto mb-16">
              <img src={AMFlagImg} className="m-auto" />
            </div>
            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1"></div>
              <div className="col-span-11">
                <div className="grid grid-cols-12">
                  <div className="col-span-3 flex items-center justify-end pr-2 text-[#5A5A5A] text-xl">
                    Name
                  </div>
                  <div className="col-span-9">
                    {/* @ts-ignore */}
                    <Input
                      className="bg-white"
                      icon={<PencilSquareIcon />}
                      value={nameEn}
                      onChange={(e) => {
                        setNameEnError(false);
                        setError(false);
                        setNameEn(e.target.value);
                      }}
                    />
                    {nameEnError ? (
                      <p className="text-red-800">
                        Please fill out this field.
                      </p>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1"></div>
              <div className="col-span-11">
                <div className="grid grid-cols-12">
                  <div className="col-span-3 flex items-center justify-end pr-2 text-[#5A5A5A] text-xl">
                    Überschrift
                  </div>
                  <div className="col-span-9">
                    {/* @ts-ignore */}
                    <Input
                      className="bg-white"
                      icon={<PencilSquareIcon />}
                      value={firstTextHeadingEn}
                      onChange={(e) => {
                        setFirstTextHeadingEnError(false);
                        setError(false);
                        setFirstTextHeadingEn(e.target.value);
                      }}
                    />
                    {firstTextHeadingEnError ? (
                      <p className="text-red-800">
                        Please fill out this field.
                      </p>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1"></div>
              <div className="col-span-11">
                <div className="grid grid-cols-12">
                  <div className="col-span-3 flex items-center justify-end pr-2 text-[#5A5A5A] text-xl">
                    Adresse
                  </div>
                  <div className="col-span-9">
                    {/* @ts-ignore */}
                    <Input
                      className="bg-white"
                      icon={<PencilSquareIcon />}
                      value={addressEn}
                      onChange={(e) => {
                        setAddressEn(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1"></div>
              <div className="col-span-11">
                <div className="grid grid-cols-12">
                  <div className="col-span-3 flex items-center justify-end pr-2 text-[#5A5A5A] text-xl">
                    Text
                  </div>
                  <div className="col-span-9">
                    <Textarea
                      className="bg-white"
                      //@ts-ignore
                      icon={<PencilSquareIcon />}
                      value={descEn}
                      onChange={(e) => {
                        setDescEnError(false);
                        setError(false);
                        setDescEn(e.target.value);
                      }}
                    />
                    {descEnError ? (
                      <p className="text-red-800">
                        Please fill out this field.
                      </p>
                    ) : null}
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1"></div>
              <div className="col-span-11">
                <div className="grid grid-cols-12">
                  <div className="col-span-3 flex items-center justify-end pr-2 text-[#5A5A5A] text-xl">
                    Audio
                  </div>
                  <div className="col-span-9">
                    <FileInput
                      className="text-[#5A5A5A]"
                      accept="audio/*"
                      id="file-upload"
                      onChange={handleFileEnChange}
                    />
                    {audioSrcEn && (
                      <audio ref={audioRefEn} controls className="mt-2">
                        {/* @ts-ignore */}
                        <source src={audioSrcEn} type="audio/mp3" />
                        Your browser does not support the audio tag.
                      </audio>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1"></div>
              <div className="col-span-11">
                <div className="grid grid-cols-12">
                  <div className="col-span-3 flex items-center justify-end pr-2 text-[#5A5A5A] text-xl">
                    AudioStory
                  </div>
                  <div className="col-span-9">
                    <FileInput
                      className="text-[#5A5A5A]"
                      accept="audio/*"
                      id="file-upload"
                      onChange={handleAudioStoryEnChange}
                    />
                    {storySrcEn && (
                      <audio ref={storyRefEn} controls className="mt-2">
                        {/* @ts-ignore */}
                        <source src={storySrcEn} type="audio/mp3" />
                        Your browser does not support the audio tag.
                      </audio>
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1"></div>
              <div className="col-span-11">
                <div className="grid grid-cols-12">
                  <div className="col-span-3 flex items-center justify-end pr-2 text-[#5A5A5A] text-xl">
                    Video Überschrift
                  </div>
                  <div className="col-span-9">
                    {/* @ts-ignore */}
                    <Input
                      className="bg-white"
                      icon={<PencilSquareIcon />}
                      value={videoNameEn}
                      onChange={(e) => {
                        setVideoNameEn(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1"></div>
              <div className="col-span-11">
                <div className="grid grid-cols-12">
                  <div className="col-span-3 flex items-center justify-end pr-2 text-[#5A5A5A] text-xl">
                    {/* Video Vorschaubild */}
                    <br />
                    <br />
                  </div>
                  <div className="col-span-9">
                    {/* <FileInput
                      className="text-[#5A5A5A]"
                      id="file-upload"
                      onChange={handleThumbEnChange}
                    /> */}
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1"></div>
              <div className="col-span-11">
                <div className="grid grid-cols-12">
                  <div className="col-span-3 flex items-center justify-end pr-2 text-[#5A5A5A] text-xl">
                    Video Link
                  </div>
                  <div className="col-span-9">
                    {/* @ts-ignore */}
                    <Input
                      className="bg-white"
                      icon={<PencilSquareIcon />}
                      value={videoLinkEn}
                      onChange={(e) => {
                        setVideoLinkEn(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="border-b-4 border-[#5A5A5A] mx-5 mb-20">
        <div className="container m-auto mt-20 pb-12"></div>
      </div>
      <div className="container m-auto mt-12">
        <div className="grid lg:grid-cols-2 gap-6">
          <div>
            <h1 className="text-[#5A5A5A] text-3xl font-normal mb-12">
              Social Media Links
            </h1>
            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1">
                <Tooltip content="Facebook-Link (ID Link)" placement="top">
                  <InformationCircleIcon
                    strokeWidth={2}
                    className="h-10 w-10 text-[#5A5A5A]"
                  ></InformationCircleIcon>
                </Tooltip>
              </div>
              <div className="col-span-11">
                <div className="grid grid-cols-12">
                  <div className="col-span-3 flex items-center justify-end pr-2 text-[#5A5A5A] text-xl">
                    Facebook
                  </div>
                  <div className="col-span-9">
                    {/* @ts-ignore */}
                    <Input
                      className="bg-white"
                      icon={<PencilSquareIcon />}
                      value={facebookDe}
                      onChange={(e) => {
                        setFacebookDe(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1">
                <Tooltip content="Instagram-Link (ID Link)" placement="top">
                  <InformationCircleIcon
                    strokeWidth={2}
                    className="h-10 w-10 text-[#5A5A5A]"
                  ></InformationCircleIcon>
                </Tooltip>
              </div>
              <div className="col-span-11">
                <div className="grid grid-cols-12">
                  <div className="col-span-3 flex items-center justify-end pr-2 text-[#5A5A5A] text-xl">
                    Instagram
                  </div>
                  <div className="col-span-9">
                    {/* @ts-ignore */}
                    <Input
                      className="bg-white"
                      icon={<PencilSquareIcon />}
                      value={instagramDe}
                      onChange={(e) => {
                        setInstagramDe(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1">
                <Tooltip content="Weblink (ID Link)" placement="top">
                  <InformationCircleIcon
                    strokeWidth={2}
                    className="h-10 w-10 text-[#5A5A5A]"
                  ></InformationCircleIcon>
                </Tooltip>
              </div>
              <div className="col-span-11">
                <div className="grid grid-cols-12">
                  <div className="col-span-3 flex items-center justify-end pr-2 text-[#5A5A5A] text-xl">
                    Weblink
                  </div>
                  <div className="col-span-9">
                    {/* @ts-ignore */}
                    <Input
                      className="bg-white"
                      icon={<PencilSquareIcon />}
                      value={weblinkDe}
                      onChange={(e) => {
                        setWeblinkDe(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <h1 className="text-[#5A5A5A] text-3xl font-normal mb-12">
              <br />
            </h1>
            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1"></div>
              <div className="col-span-11">
                <div className="grid grid-cols-12">
                  <div className="col-span-3 flex items-center justify-end pr-2 text-[#5A5A5A] text-xl">
                    Facebook
                  </div>
                  <div className="col-span-9">
                    {/* @ts-ignore */}
                    <Input
                      className="bg-white"
                      icon={<PencilSquareIcon />}
                      value={facebookEn}
                      onChange={(e) => {
                        setFacebookEn(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1"></div>
              <div className="col-span-11">
                <div className="grid grid-cols-12">
                  <div className="col-span-3 flex items-center justify-end pr-2 text-[#5A5A5A] text-xl">
                    Instagram
                  </div>
                  <div className="col-span-9">
                    {/* @ts-ignore */}
                    <Input
                      className="bg-white"
                      icon={<PencilSquareIcon />}
                      value={instagramEn}
                      onChange={(e) => {
                        setInstagramEn(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1"></div>
              <div className="col-span-11">
                <div className="grid grid-cols-12">
                  <div className="col-span-3 flex items-center justify-end pr-2 text-[#5A5A5A] text-xl">
                    Weblink
                  </div>
                  <div className="col-span-9">
                    {/* @ts-ignore */}
                    <Input
                      className="bg-white"
                      icon={<PencilSquareIcon />}
                      value={weblinkEn}
                      onChange={(e) => {
                        setWeblinkEn(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="border-b-4 border-[#5A5A5A] mx-5 mb-20">
        <div className="container m-auto mt-20 pb-12"></div>
      </div>
      <div className="container m-auto mt-12">
        <h1 className="text-[#5A5A5A] text-3xl font-normal mb-12">Bilder</h1>
        <div className="grid grid-cols-12 gap-4 items-center mb-6">
          <div className="col-span-1">
            <Tooltip
              content="Format: Querformat, max. Dateigröße 200kB"
              placement="top"
            >
              <InformationCircleIcon
                strokeWidth={2}
                className="h-10 w-10 text-[#5A5A5A]"
              ></InformationCircleIcon>
            </Tooltip>
          </div>
          <div className="col-span-11"></div>
        </div>
        <div className="grid grid-cols-12 gap-4 items-center mb-6">
          <div className="col-span-1"></div>
          <div className="col-span-11">
            {images.map((image, index) => {
              return !image.isHidden ? (
                <div key={index}>
                  <div className="grid grid-cols-12 mb-6">
                    <div className="col-span-1 flex items-center justify-end pr-2 text-[#5A5A5A] text-xl">
                      Text
                    </div>
                    <div className="col-span-5">
                      {/* @ts-ignore */}
                      <Input
                        className="bg-white"
                        icon={<PencilSquareIcon />}
                        value={image.imageDescriptionDe}
                        onChange={(e) => {
                          handleInputDeChange(index, e);
                        }}
                      />
                    </div>
                    <div className="col-span-1 flex items-center justify-end pr-2 text-[#5A5A5A] text-xl">
                      Text
                    </div>
                    <div className="col-span-5">
                      {/* @ts-ignore */}
                      <Input
                        className="bg-white"
                        icon={<PencilSquareIcon />}
                        value={image.imageDescriptionEn}
                        onChange={(e) => {
                          handleInputEnChange(index, e);
                        }}
                      />
                    </div>
                  </div>
                  <div className="grid grid-cols-12 mb-6">
                    <div className="col-span-1 flex items-center justify-end pr-2 text-[#5A5A5A] text-xl"></div>
                    <div className="col-span-11">
                      <FileInput
                        className="text-[#5A5A5A]"
                        id="file-upload"
                        accept="image/*"
                        onChange={(e) => handleBilderChange(index, e)}
                      />
                      {image.previewUrl && (
                        <div className="relative mt-2 w-[max-content]">
                          {/* Thumbnail Preview */}
                          <img
                            src={image.previewUrl}
                            alt="Preview"
                            className="w-72 h-auto rounded-lg shadow-lg cursor-pointer transition-transform hover:scale-105"
                            onClick={() => modalToggle(index, true)} // Open modal on click
                          />

                          {/* Full-Size Modal */}
                          {image.isModalOpen && (
                            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                              <img
                                src={image.previewUrl}
                                alt="Full Size Preview"
                                className="max-w-full max-h-full rounded-lg shadow-xl"
                              />
                              <button
                                className="absolute top-4 right-4 bg-white text-black p-2 rounded-full shadow-md"
                                onClick={() => modalToggle(index, false)} // Close modal on click
                              >
                                ✕
                              </button>
                            </div>
                          )}
                          <TrashIcon
                            strokeWidth={2}
                            className="h-6 w-6 text-[#5A5A5A]  cursor-pointer m-auto mt-2 transition"
                            onClick={() => removeImage(index)}
                          ></TrashIcon>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              ) : null;
            })}
          </div>
        </div>
        <div className="text-center mt-2">
          <div
            className="text-[#5A5A5A] text-xl text-center mt-2 inline-flex items-center"
            onClick={addNewImage}
          >
            Neues Bild hinzufügen
            <PlusCircleIcon strokeWidth={2} color="#5A5A5A" className="h-6 w-6">
              {" "}
            </PlusCircleIcon>
          </div>
        </div>
      </div>
      <div className="border-b-4 border-[#5A5A5A] mx-5 mb-20">
        <div className="container m-auto mt-20 pb-12"></div>
      </div>
      <div className="container m-auto mt-12">
        <div className="grid lg:grid-cols-2 gap-6">
          <div>
            <h1 className="text-[#5A5A5A] text-3xl font-normal mb-12">Tipp</h1>
            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1">
                <Tooltip
                  content="Unbegrenzte Anzahl an Zeichen"
                  placement="top"
                >
                  <InformationCircleIcon
                    strokeWidth={2}
                    className="h-10 w-10 text-[#5A5A5A]"
                  ></InformationCircleIcon>
                </Tooltip>
              </div>
              <div className="col-span-11">
                <div className="grid grid-cols-12">
                  <div className="col-span-3 flex items-center justify-end pr-2 text-[#5A5A5A] text-xl">
                    Beschreibung
                  </div>
                  <div className="col-span-9">
                    {/* @ts-ignore */}
                    <Input
                      className="bg-white"
                      icon={<PencilSquareIcon />}
                      value={tipDescDe}
                      onChange={(e) => {
                        setTipDescDe(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1">
                <Tooltip content="Tip Link" placement="top">
                  <InformationCircleIcon
                    strokeWidth={2}
                    className="h-10 w-10 text-[#5A5A5A]"
                  ></InformationCircleIcon>
                </Tooltip>
              </div>
              <div className="col-span-11">
                <div className="grid grid-cols-12">
                  <div className="col-span-3 flex items-center justify-end pr-2 text-[#5A5A5A] text-xl">
                    Link
                  </div>
                  <div className="col-span-9">
                    {/* @ts-ignore */}
                    <Input
                      className="bg-white"
                      icon={<PencilSquareIcon />}
                      value={tipLinkDe}
                      onChange={(e) => {
                        setTipLinkDe(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1">
                <Tooltip
                  content="Format: Querformat, max. Dateigröße 200kB"
                  placement="top"
                >
                  <InformationCircleIcon
                    strokeWidth={2}
                    className="h-10 w-10 text-[#5A5A5A]"
                  ></InformationCircleIcon>
                </Tooltip>
              </div>
              <div className="col-span-11">
                <div className="grid grid-cols-12">
                  <div className="col-span-3 flex items-center justify-end pr-2 text-[#5A5A5A] text-xl">
                    Bild
                  </div>
                  <div className="col-span-9">
                    <FileInput
                      className="text-[#5A5A5A]"
                      accept="image/*"
                      id="file-upload"
                      onChange={handleTipDeChange}
                    />
                    {tipSrcDe && (
                      <div className="relative mt-2 w-[max-content]">
                        {/* Thumbnail Preview */}
                        <img
                          // @ts-ignore
                          src={tipSrcDe}
                          alt="Preview"
                          className="w-72 h-auto rounded-lg shadow-lg cursor-pointer transition-transform hover:scale-105"
                          onClick={() => modalToggleTip(true)} // Open modal on click
                        />

                        {/* Full-Size Modal */}
                        {isModalOpenTip && (
                          <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                            <img
                              // @ts-ignore
                              src={tipSrcDe}
                              alt="Full Size Preview"
                              className="max-w-full max-h-full rounded-lg shadow-xl"
                            />
                            <button
                              className="absolute top-4 right-4 bg-white text-black p-2 rounded-full shadow-md"
                              onClick={() => modalToggleTip(false)} // Close modal on click
                            >
                              ✕
                            </button>
                          </div>
                        )}
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <h1 className="text-[#5A5A5A] text-3xl font-normal mb-12">
              <br />
            </h1>

            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1"></div>
              <div className="col-span-11">
                <div className="grid grid-cols-12">
                  <div className="col-span-3 flex items-center justify-end pr-2 text-[#5A5A5A] text-xl">
                    Beschreibung
                  </div>
                  <div className="col-span-9">
                    {/* @ts-ignore */}
                    <Input
                      className="bg-white"
                      icon={<PencilSquareIcon />}
                      value={tipDescEn}
                      onChange={(e) => {
                        setTipDescEn(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1"></div>
              <div className="col-span-11">
                <div className="grid grid-cols-12">
                  <div className="col-span-3 flex items-center justify-end pr-2 text-[#5A5A5A] text-xl">
                    Link
                  </div>
                  <div className="col-span-9">
                    {/* @ts-ignore */}
                    <Input
                      className="bg-white"
                      icon={<PencilSquareIcon />}
                      value={tipLinkEn}
                      onChange={(e) => {
                        setTipLinkEn(e.target.value);
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1"></div>
              <div className="col-span-11">
                <div className="grid grid-cols-12">
                  <div className="col-span-3 flex items-center justify-end pr-2 text-[#5A5A5A] text-xl">
                    <br />
                  </div>
                  <div className="col-span-9">
                    {/* <FileInput
                      className="text-[#5A5A5A]"
                      id="file-upload"
                      onChange={handleTipEnChange}
                    /> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="border-b-4 border-[#5A5A5A] mx-5 mb-20">
        <div className="container m-auto mt-20 pb-12"></div>
      </div>
      <div className="container m-auto">
        <div className="grid gap-6">
          <div>
            <h1 className="text-[#5A5A5A] text-3xl font-normal mb-12">
              AR-Szene oder Panoramabild hinzufügen
            </h1>
            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1">
                <Tooltip
                  content="Auswählen, wenn AR-Szene vorhanden"
                  placement="top"
                >
                  <InformationCircleIcon
                    strokeWidth={2}
                    className="h-10 w-10 text-[#5A5A5A]"
                  ></InformationCircleIcon>
                </Tooltip>
              </div>
              <div className="col-span-2 flex items-center justify-center pr-2 text-[#5A5A5A] text-xl"></div>
              <div className="col-span-9">
                {/* @ts-ignore */}
                <Checkbox
                  checked={isAR}
                  onChange={(e) => setIsAR(e.target.checked)}
                  label={
                    //@ts-ignore */}
                    <Typography className="flex font-semibold text-[#5A5A5A]">
                      AR
                    </Typography>
                  }
                />
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1">
                <Tooltip
                  content="Auswählen, wenn die AR-Szene ein Panorama ist"
                  placement="top"
                >
                  <InformationCircleIcon
                    strokeWidth={2}
                    className="h-10 w-10 text-[#5A5A5A]"
                  ></InformationCircleIcon>
                </Tooltip>
              </div>
              <div className="col-span-2 flex items-center justify-center pr-2 text-[#5A5A5A] text-xl"></div>
              <div className="col-span-9">
                {/* @ts-ignore */}
                <Checkbox
                  checked={isPanorama}
                  onChange={(e) => setIsPanorama(e.target.checked)}
                  label={
                    //@ts-ignore */}
                    <Typography className="flex font-semibold text-[#5A5A5A]">
                      Panorama
                    </Typography>
                  }
                />
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1">
                <Tooltip content="Zugewiesene Datei hochladen" placement="top">
                  <InformationCircleIcon
                    strokeWidth={2}
                    className="h-10 w-10 text-[#5A5A5A]"
                  ></InformationCircleIcon>
                </Tooltip>
              </div>
              <div className="col-span-2 flex items-center justify-center pr-2 text-[#5A5A5A] text-xl">
                AR Standort
              </div>
              <div className="col-span-9">
                <FileInput
                  className="text-[#5A5A5A]"
                  accept="image/*"
                  id="file-upload"
                  onChange={handleFileARImageChange}
                />
                {arImageSrcDe && (
                  <div className="relative mt-2 w-[max-content]">
                    {/* Thumbnail Preview */}
                    <img
                      // @ts-ignore */}
                      src={arImageSrcDe}
                      alt="Preview"
                      className="w-72 h-auto rounded-lg shadow-lg cursor-pointer transition-transform hover:scale-105"
                      onClick={() => modalToggleAR(true)} // Open modal on click
                    />

                    {/* Full-Size Modal */}
                    {isModalOpenAR && (
                      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <img
                          // @ts-ignore */}
                          src={arImageSrcDe}
                          alt="Full Size Preview"
                          className="max-w-full max-h-full rounded-lg shadow-xl"
                        />
                        <button
                          className="absolute top-4 right-4 bg-white text-black p-2 rounded-full shadow-md"
                          onClick={() => modalToggleAR(false)} // Close modal on click
                        >
                          ✕
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
            <div className="grid grid-cols-12 gap-4 items-center mb-6">
              <div className="col-span-1">
                <Tooltip content="Zugewiesene Datei hochladen" placement="top">
                  <InformationCircleIcon
                    strokeWidth={2}
                    className="h-10 w-10 text-[#5A5A5A]"
                  ></InformationCircleIcon>
                </Tooltip>
              </div>
              <div className="col-span-2 flex items-center justify-center pr-2 text-[#5A5A5A] text-xl">
                Panoramabild
              </div>
              <div className="col-span-9">
                <FileInput
                  className="text-[#5A5A5A]"
                  accept="image/*"
                  id="file-upload"
                  onChange={handleFilePanoramaImageChange}
                />
                {panoramaImageSrcDe && (
                  <div className="relative mt-2 w-[max-content]">
                    {/* Thumbnail Preview */}
                    <img
                      // @ts-ignore */}
                      src={panoramaImageSrcDe}
                      alt="Preview"
                      className="w-72 h-auto rounded-lg shadow-lg cursor-pointer transition-transform hover:scale-105"
                      onClick={() => modalTogglePanorama(true)} // Open modal on click
                    />

                    {/* Full-Size Modal */}
                    {isModalOpenPanorama && (
                      <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
                        <img
                          // @ts-ignore */}
                          src={panoramaImageSrcDe}
                          alt="Full Size Preview"
                          className="max-w-full max-h-full rounded-lg shadow-xl"
                        />
                        <button
                          className="absolute top-4 right-4 bg-white text-black p-2 rounded-full shadow-md"
                          onClick={() => modalTogglePanorama(false)} // Close modal on click
                        >
                          ✕
                        </button>
                      </div>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="border-b-4 border-[#5A5A5A] mx-5 mb-20">
        <div className="container m-auto mt-20 pb-12"></div>
      </div>
      <div className="container m-auto mb-40">
        <h1 className="text-[#5A5A5A] text-3xl font-normal mb-12">Weiteres</h1>
        <div className="grid grid-cols-12 gap-4 items-center mb-6">
          <div className="col-span-1">
            <Tooltip
              content="Soll der POI in der App in der Übersicht ausgeblendet werden?"
              placement="top"
            >
              <InformationCircleIcon
                strokeWidth={2}
                className="h-10 w-10 text-[#5A5A5A]"
              ></InformationCircleIcon>
            </Tooltip>
          </div>
          <div className="col-span-2"></div>
          <div className="col-span-9">
            {/* @ts-ignore */}
            <Checkbox
              checked={willbeHidden}
              onChange={(e) => setWillbeHidden(e.target.checked)}
              label={
                // @ts-ignore */}
                <Typography className="flex font-semibold text-[#5A5A5A]">
                  Ausblenden in POI Übersicht
                </Typography>
              }
            />
          </div>
        </div>
        <div className="grid grid-cols-12 gap-4 items-center mb-20">
          <div className="col-span-1">
            <Tooltip
              content="GPS-Koordinaten Schreibweise: Eingabe von Längen- und Breitengrad nach Google, mit Komma separiert (z.B. „53.5430895,8.5057031“)"
              placement="top"
            >
              <InformationCircleIcon
                strokeWidth={2}
                className="h-10 w-10 text-[#5A5A5A]"
              ></InformationCircleIcon>
            </Tooltip>
          </div>
          <div className="col-span-2 text-[#5A5A5A] text-xl">GPS</div>
          <div className="col-span-9">
            {/* @ts-ignore */}
            <Input
              className="bg-white"
              icon={<PencilSquareIcon />}
              value={GPS}
              onChange={(e) => {
                setGPS(e.target.value);
                setGPSError(false);
                setError(false);
              }}
            />
            {GPSError ? (
              <p className="text-red-800">Please fill out this field.</p>
            ) : null}
          </div>
        </div>
        <div className="grid lg:grid-cols-6">
          <div className="col-span-4">
            {/* @ts-ignore */}
            <Checkbox
              checked={published}
              onChange={(e) => setPublished(e.target.checked)}
              label={
                // @ts-ignore */}
                <Typography className="flex font-semibold text-[#5A5A5A]">
                  Veröffentlichen
                </Typography>
              }
            />
          </div>
          <div>
            <Link to="/poi">
              {/* @ts-ignore */}
              <Button
                variant="outlined"
                className="text-[#5A5A5A] px-10 bg-white border-none"
              >
                Abbrechen
              </Button>
            </Link>
          </div>
          <div>
            {/* @ts-ignore */}
            <Button
              variant="outlined"
              className="text-[#5A5A5A] px-10 bg-white border-none hover:text-red-800"
              onClick={onSubmit}
            >
              Speichern
            </Button>
            {error ? (
              <div className="text-red-800 mt-2">
                Bitte fülle alle Pflichtfelder aus.
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </>
  );
};

export default NewPoiPage;
